import Model, { attr, belongsTo } from "@ember-data/model";

export default class ServerCostModel extends Model {
  @attr costs;

  @belongsTo("server", { async: false, inverse: "costs" }) server;
}
